import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { useShowAgent } from "../../CommunityBot/agentsQueries";

export interface AvatarProps {
  communityBotProfileId: number;
}

export const AiAgentAvatar = ({ communityBotProfileId }: AvatarProps) => {
  const { data: communityBotProfile, isLoading } = useShowAgent({
    id: communityBotProfileId,
  });

  if (isLoading) {
    return (
      <span className="bg-tertiary block h-4 w-full animate-pulse rounded" />
    );
  }

  if (!communityBotProfile) {
    return (
      <span className="text-sm">
        {t("settings.workflows.action_messages.ai_agents.missing_agent")}
      </span>
    );
  }

  const { name, avatar_url: src } = communityBotProfile;

  return (
    <>
      <span className="pl-2">
        <div className="float-left">
          {src ? (
            <UserImageWithFallback size="6" src={src} name={name} />
          ) : (
            <Icon type="24-ai-bot" size={24} className="!h-6 !w-6" />
          )}
        </div>
      </span>
      <span className="break-normal text-sm">{name}</span>
    </>
  );
};
